import { useNavigate, useLocation } from "react-router-dom";
import classNames from "classnames";
import styles from "./style.module.scss";

export interface MobileNavItem {
  path: string;
  label: string;
  icon: any;
}

interface MobileNavigationProps {
  navItems: MobileNavItem[];
}

function MobileNavigation({ navItems }: MobileNavigationProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path: string) => {
    return pathname === path || pathname.startsWith(path);
  };

  return (
    <nav className={classNames(styles.mobileNav)}>
      {navItems.map((item) => {
        const active = isActive(item.path);
        const Icon = item.icon;

        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={classNames(styles.navItem, {
              [styles.active]: active,
            })}
          >
            <div className={styles.iconWrapper}>
              <Icon className={styles.icon} />
            </div>
            <span className={styles.label}>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default MobileNavigation;
